/**
 * @param {Array<object>} preguntas
 * @returns {Array<object>}
 */
export function shuffleQuestionOrder(preguntas) {
  const list = Array.isArray(preguntas) ? [...preguntas] : [];
  for (let i = list.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = list[i];
    list[i] = list[j];
    list[j] = tmp;
  }
  return list;
}

/**
 * @param {Array<object>} preguntas
 * @param {number | null | undefined} preguntasPorIntento
 * @returns {Array<object>}
 */
export function selectPreguntasPorIntento(preguntas, preguntasPorIntento) {
  const list = Array.isArray(preguntas) ? [...preguntas] : [];
  if (list.length === 0) {
    return [];
  }

  let limit = list.length;
  if (
    typeof preguntasPorIntento === "number" &&
    Number.isFinite(preguntasPorIntento) &&
    preguntasPorIntento > 0
  ) {
    limit = Math.max(1, Math.floor(preguntasPorIntento));
  }
  limit = Math.min(limit, list.length);

  return shuffleQuestionOrder(list).slice(0, limit);
}

/**
 * Uses server-sampled questions when the API already reduced the bank; otherwise samples client-side.
 *
 * @param {Array<object>} preguntas
 * @param {number | null | undefined} preguntasPorIntento
 * @param {number | null | undefined} totalPreguntasEnBanco
 * @returns {Array<object>}
 */
export function resolvePreguntasParaTestAttempt(preguntas, preguntasPorIntento, totalPreguntasEnBanco) {
  const list = Array.isArray(preguntas) ? preguntas : [];
  if (
    typeof totalPreguntasEnBanco === "number" &&
    Number.isFinite(totalPreguntasEnBanco) &&
    totalPreguntasEnBanco > list.length
  ) {
    return shuffleQuestionOrder(list);
  }
  return selectPreguntasPorIntento(list, preguntasPorIntento);
}
